import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function ServicetypeReducer(state = initialState.servicetype, action: any) {
  switch (action.type) {
    case types.SAVE_SERVICETYPE_SUCCESS:
      return action.servicetype;
    default:
      return state;
  }
}
